import { createGlobalStyle } from "styled-components";
import colors from "./colors.js";
import mediaQuery from "./mediaQuery.js";
const GlobalStyle = createGlobalStyle` main {}


* {
	margin: 0;
	padding: 0;
	font-family: 'TT Hoves Pro', sans-serif;
	font-display: swap;
	font-weight: 400;
	color: ${colors.white};
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	font-weight: lighter;
	border: none;
    box-sizing: border-box;
	@media (min-width: 1440px) {
	}
}

div[data-placeholder-image] {
	background-color: transparent !important;
}


html {

	font-size: 62.5%;
	@media (min-width: 1730px) {
		font-size: 0.578vw;
		font-size: clamp(62.5%, .578vw, 75%);
	}
}

body {

	font-size: 1.4rem;
	background-color: ${colors.blue};
}

* {
	cursor: none !important;
	@media (pointer: coarse) {
		cursor: auto !important;
	}
	@media (max-width: ${mediaQuery.tablet}) {
		cursor: auto !important;
	}
}

h1,
h2,
h3,
h4,
h5,
h6 {}

strong {}

button {
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	background: transparent;
	color: inherit;
	font: inherit;
	line-height: normal;
	-webkit-font-smoothing: inherit;
	-moz-osx-font-smoothing: inherit;
	-webkit-appearance: none;


}


::selection {
	background-color: ${colors.white};
	color: ${colors.dark};
}

::-moz-selection {
	background-color: ${colors.white}95;
	color: black;
}

`;

export default GlobalStyle;
